import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '"Is this just another diet?"',
  answer: "No. We don't ask you to eliminate food groups or count calories. We ask you to add 10 specific ingredients prepared in a specific way for 7 days. Most people eat practically the same as always, they simply add the protocol."
}, {
  question: '"Does it work for rheumatoid arthritis or only osteoarthritis?"',
  answer: 'The protocol addresses chronic low-grade inflammation present in both conditions. However, rheumatoid arthritis is an autoimmune disease that requires medical supervision. Consult your doctor before starting.'
}, {
  question: '"How long do I have to follow it?"',
  answer: 'The intensive protocol is 7 days. Afterward there is a simple maintenance phase you can follow for life with very little effort and a cost of approximately $12-15 dollars a week.'
}, {
  question: '"What if I don\'t have time to cook?"',
  answer: 'The longest preparations in the protocol take 20 minutes. The bone broth makes itself while you sleep. The Morning Flush takes 2 minutes. The Golden Paste is prepared once and lasts 2 weeks.'
}, {
  question: '"Why does it only cost $7 if it\'s worth $34?"',
  answer: "Because our goal at VitalyForms is that price should never be the reason a woman over 55 continues suffering unnecessary joint pain. If it works for you, you're going to recommend it to someone else. That's our growth strategy."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <FadeIn data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-black mb-12" data-id="element-23">
            Questions You Probably Have:
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-25">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-26">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-27">
                  <span className="font-bold text-lg text-forest-green pr-8" data-id="element-28">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-29" />
                </button>
                <AnimatePresence data-id="element-30">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-31">
                      <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-32">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}